import { ListChecks } from "lucide-react";

export function JobInfo({ job, big }) {
  if (!job) return null;
  return (
    <div className="space-y-3" data-testid="job-info">
      <div>
        <div className="text-sm text-muted-foreground">{job.customer_name}</div>
        <div className={`font-heading font-extrabold ${big ? "text-2xl" : "text-lg"}`} data-testid="job-info-name">{job.job_name || job.job_number}</div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">{job.job_number}{job.job_type ? ` · ${job.job_type}` : ""}{job.quantity ? ` · Qty ${job.quantity}` : ""}{job.due_date ? ` · Due ${job.due_date}` : ""}</div>
      </div>
      {job.description && <p className={`whitespace-pre-wrap ${big ? "text-base" : "text-sm"}`} data-testid="job-info-desc">{job.description}</p>}
      {job.stages?.length > 0 && (
        <div>
          <div className="text-xs font-bold uppercase mb-2 flex items-center gap-1.5"><ListChecks className="w-4 h-4 text-primary" />Tasks on this job</div>
          <div className="flex flex-wrap gap-1.5" data-testid="job-task-list">
            {job.stages.map((s) => <span key={s.id} className={`px-2.5 py-1 rounded-md bg-accent/60 border border-border font-semibold ${big ? "text-sm" : "text-xs"}`}>{s.name}</span>)}
          </div>
        </div>
      )}
    </div>
  );
}
